
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { ProductCategoryService, ProductCategoryDto } from "@/api/service-proxies";
import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";

class TenantPagedRequest extends PagedRequestDto {
  name!: string;
}

@Component({
  name: "Tenant",
  components: {
    Pagination


  }
})
export default class Tenant extends PagedListBase<
  TenantPagedRequest,
  ProductCategoryDto
> {
  request = new TenantPagedRequest();
  productcategoryService = new ProductCategoryService();

  created() {
    this.refresh();
  }

  getpage(finishCallback: Function): void {
    this.productcategoryService
      .getAll(
        this.request.name,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  handleCreate() {
    this.$router.push({ path: "/product/productcategory/create" });
  }
  handleUpdate(product: ProductCategoryDto) {
    this.$router.push({ path: `/product/productcategory/update/${product.id}` });
  }
  handleDelete(product: ProductCategoryDto) {
    this.$confirm("确定删除产品分类?")
      .then(async () => {
        await this.productcategoryService.delete(product.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }

  //状态改变事件
  statusSwitchChange(product: ProductCategoryDto) {

this.productcategoryService.switchChange(product);

}

}

